"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CargoImageHint = _interopRequireDefault(require("./CargoImageHint"));
var _reactTransitionGroup = require("react-transition-group");
var _map2 = _interopRequireDefault(require("lodash/map"));
require("./CargoGame.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var fadeTransitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  }
};
var zoom235TransitionStyles = {
  entering: {
    width: 0,
    height: 0,
    opacity: 0
  },
  entered: {
    width: 235,
    height: 235,
    opacity: 1
  }
};
var CargoGame = /*#__PURE__*/function (_Component) {
  _inherits(CargoGame, _Component);
  var _super = _createSuper(CargoGame);
  function CargoGame(props) {
    var _this;
    _classCallCheck(this, CargoGame);
    _this = _super.call(this, props);
    _this.state = {
      screen: 1,
      width: 1024,
      height: 720,
      contentScale: 1,
      activeHint: 0,
      questions: [],
      feedbackItem: null,
      feedbackText: null,
      transitions: {
        startButton: false,
        mainImage: false,
        mainImageLabel: false,
        feedbackSolution: false,
        leftInfo: false,
        rightInfo: false,
        hints: {
          hint1: false,
          hint2: false,
          hint3: false,
          hint4: false,
          hint5: false,
          hint6: false,
          hint7: false,
          hint8: false,
          hint9: false
        },
        solutions: {
          hint1: false,
          hint2: false,
          hint3: false,
          hint4: false,
          hint5: false,
          hint6: false,
          hint7: false,
          hint8: false,
          hint9: false
        }
      }
    };
    _this.processAnswer = _this.processAnswer.bind(_assertThisInitialized(_this));
    _this.changeScreen = _this.changeScreen.bind(_assertThisInitialized(_this));
    _this.resizingWindow = _this.resizingWindow.bind(_assertThisInitialized(_this));

    // Transitions
    // setTimeout(() => {
    //   this.setState({ transitions: {startButton:!this.state.transitions.startButton} })
    // }, 1000)
    return _this;
  }
  _createClass(CargoGame, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var tempQuestions = this.state.questions;
      this.props.items && (0, _map2["default"])(this.props.items, function (item) {
        tempQuestions.push(item);
      });
      var shuffleArray = function shuffleArray(arr) {
        return arr.sort(function () {
          return Math.random() - 0.5;
        });
      };
      var shuffledArray = shuffleArray(tempQuestions);
      this.setState({
        questions: shuffledArray
      });

      // Transitions
      setTimeout(function () {
        _this2.setState(function (prevState) {
          return {
            transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
              startButton: true
            })
          };
        });
      }, 1000);

      // Zooming content to width of screen
      var interval = setInterval(function () {
        var cargoGameContainerW = _this2.cargoGameContainer ? _this2.cargoGameContainer.clientWidth : null;
        var cargoGameContainerH = _this2.cargoGameContainer ? _this2.cargoGameContainer.clientHeight : null;
        var windowW = window.innerWidth;
        var windowH = window.innerHeight;
        if (cargoGameContainerW && cargoGameContainerH) {
          var r = 1;
          r = Math.min(windowW / cargoGameContainerW, windowH / cargoGameContainerH);
          _this2.setState({
            contentScale: r
          });
          clearInterval(interval);
        }
      }, 300);
      window.addEventListener("resize", this.resizingWindow);
    }
  }, {
    key: "resizingWindow",
    value: function resizingWindow() {
      var cargoGameContainerW = this.cargoGameContainer ? this.cargoGameContainer.clientWidth : null;
      var cargoGameContainerH = this.cargoGameContainer ? this.cargoGameContainer.clientHeight : null;
      var windowW = window.innerWidth;
      var windowH = window.innerHeight;
      var r = 1;
      r = Math.min(windowW / cargoGameContainerW, windowH / cargoGameContainerH);
      this.setState({
        contentScale: r
      });
    }
  }, {
    key: "processAnswer",
    value: function processAnswer(id) {
      var _this3 = this;
      if (id === this.state.questions[this.state.activeHint].id) {
        // Displaying feedback
        var newActiveHint = this.state.activeHint + 1;
        this.setState({
          feedbackItem: id,
          feedbackText: "Correct!"
        });

        // 1. Hiding label
        setTimeout(function () {
          _this3.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                rightInfo: false,
                mainImageLabel: false,
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, _defineProperty({}, id, false))
              })
            };
          });
        }, 500);

        // 2. Hiding main image
        setTimeout(function () {
          _this3.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                mainImage: false
              })
            };
          });
        }, 800);
        setTimeout(function () {
          // Preparing current item to be set as processed
          // Updating pointer to new element - changing main image - text etc.
          var questions = _this3.state.questions;
          questions[_this3.state.activeHint].processed = true;
          var screen = 2;
          if (newActiveHint > _this3.state.questions.length - 1) {
            screen = 3;
          }
          _this3.setState(function (prevState) {
            return {
              activeHint: newActiveHint,
              feedbackItem: null,
              questions: questions,
              screen: screen
            };
          });
          if (screen === 3) {
            setTimeout(function () {
              _this3.setState(function (prevState) {
                return {
                  transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                    feedbackSolution: true
                  })
                };
              });
            }, 500);
          }
        }, 1300);
        setTimeout(function () {
          _this3.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                solutions: _objectSpread(_objectSpread({}, prevState.transitions.solutions), {}, _defineProperty({}, id, true)),
                rightInfo: true,
                mainImage: true
              })
            };
          });
        }, 1500);
        setTimeout(function () {
          _this3.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                mainImageLabel: true
              })
            };
          });
        }, 2100);
      } else {
        this.setState({
          feedbackItem: id,
          feedbackText: "Try Again!"
        });
        setTimeout(function () {
          _this3.setState(function (prevState) {
            return {
              feedbackItem: null
            };
          });
        }, 2000);
      }
    }
  }, {
    key: "changeScreen",
    value: function changeScreen(screen) {
      var _this4 = this;
      // After 1sec - we change screen
      setTimeout(function () {
        _this4.setState({
          screen: screen
        });
      }, 800);
      if (screen === 2) {
        this.setState(function (prevState) {
          return {
            transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
              startButton: false
            })
          };
        });
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                leftInfo: true,
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint1: true
                })
              })
            };
          });
        }, 1100);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint5: true
                })
              })
            };
          });
        }, 1400);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint8: true
                })
              })
            };
          });
        }, 1700);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint4: true
                })
              })
            };
          });
        }, 2000);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint9: true
                })
              })
            };
          });
        }, 2200);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint2: true
                })
              })
            };
          });
        }, 2500);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                mainImage: true,
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint3: true
                })
              })
            };
          });
        }, 2700);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint6: true
                })
              })
            };
          });
        }, 3000);
        setTimeout(function () {
          _this4.setState(function (prevState) {
            return {
              transitions: _objectSpread(_objectSpread({}, prevState.transitions), {}, {
                mainImageLabel: true,
                rightInfo: true,
                hints: _objectSpread(_objectSpread({}, prevState.transitions.hints), {}, {
                  hint7: true
                })
              })
            };
          });
        }, 3200);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "cargo-game-container",
        ref: function ref(input) {
          _this5.cargoGameContainer = input;
        },
        style: {
          transform: 'scale(' + this.state.contentScale + ') translate(-50%, -50%)'
        }
      }, this.state.screen === 1 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "intro-text"
      }, /*#__PURE__*/_react["default"].createElement("h1", null, this.props.introTitle)) : null, this.state.questions.length > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "cargo-game",
        style: {
          width: this.state.width,
          height: this.state.height
        }
      }, this.state.screen === 2 && this.state.questions && (0, _map2["default"])(this.state.questions, function (item) {
        if (item.processed) {
          return null;
        }
        {
          return typeof _this5.state.transitions.hints === 'undefined' ? null : /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
            "in": _this5.state.transitions.hints[item.id],
            key: item.id,
            timeout: 800
          }, function (state) {
            return /*#__PURE__*/_react["default"].createElement(_CargoImageHint["default"], {
              isActiveFeedback: _this5.state.feedbackItem === item.id,
              style: _objectSpread({
                transition: "opacity 800ms ease-in-out",
                opacity: 0
              }, fadeTransitionStyles[state]),
              feedbackText: _this5.state.feedbackItem === item.id ? _this5.state.feedbackText : '',
              src: item.hintSrc,
              x: item.coords.x,
              y: item.coords.y,
              processAnswerAction: function processAnswerAction() {
                return _this5.processAnswer(item.id);
              }
            });
          });
        }
      }), this.state.screen !== 1 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "sprites-container"
      }, this.state.questions && (0, _map2["default"])(this.state.questions, function (item) {
        if (item.processed) {
          return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
            "in": _this5.state.transitions.solutions[item.id],
            key: item.id,
            timeout: 500
          }, function (state) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: "sprite ".concat(item.id),
              key: "sprite_".concat(item.id),
              style: _objectSpread({
                backgroundImage: "url('" + _this5.props.spritesSrc + "')",
                backgroundRepeat: "no-repeat",
                transition: "opacity 500ms ease-in-out",
                opacity: 0
              }, fadeTransitionStyles[state])
            });
          });
        }
      })) : null, this.state.screen === 1 ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.transitions.startButton,
        timeout: 800
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "intro-content",
          style: _objectSpread({
            transition: "opacity 800ms ease-in-out",
            opacity: 0
          }, fadeTransitionStyles[state])
        }, /*#__PURE__*/_react["default"].createElement("p", {
          dangerouslySetInnerHTML: {
            __html: _this5.props.introText
          }
        }), /*#__PURE__*/_react["default"].createElement("a", {
          className: "start-button",
          onClick: function onClick() {
            return _this5.changeScreen(2);
          }
        }, "Start"));
      }) : null, this.state.screen === 2 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "info-container"
      }, /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.transitions.leftInfo,
        timeout: 800
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "left-info",
          style: _objectSpread({
            transition: "opacity 800ms ease-in-out",
            opacity: 0
          }, fadeTransitionStyles[state])
        }, /*#__PURE__*/_react["default"].createElement("h3", null, "Select a location to place the cargo."));
      }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.transitions.mainImage,
        timeout: 500
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "center-info"
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "center-circle",
          style: _objectSpread({
            transition: "all 500ms ease-in-out",
            width: 0,
            height: 0,
            opacity: 0
          }, zoom235TransitionStyles[state])
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "center-icon-image",
          style: {
            backgroundImage: "url(\'" + _this5.state.questions[_this5.state.activeHint].imageSrc + "\')"
          }
        }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
          "in": _this5.state.transitions.mainImageLabel,
          timeout: 300
        }, function (state) {
          return /*#__PURE__*/_react["default"].createElement("label", {
            style: _objectSpread({
              transition: "opacity 300ms ease-in-out",
              opacity: 0
            }, fadeTransitionStyles[state]),
            dangerouslySetInnerHTML: {
              __html: _this5.state.questions[_this5.state.activeHint].title
            }
          });
        })));
      }), /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.transitions.rightInfo,
        timeout: 800
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "right-info",
          style: _objectSpread({
            transition: "opacity 800ms ease-in-out",
            opacity: 0
          }, fadeTransitionStyles[state])
        }, /*#__PURE__*/_react["default"].createElement("p", {
          dangerouslySetInnerHTML: {
            __html: _this5.state.questions[_this5.state.activeHint].description
          }
        }));
      })) : null, this.state.screen === 3 ? /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
        "in": this.state.transitions.feedbackSolution,
        timeout: 800
      }, function (state) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "complete-message",
          style: _objectSpread({
            transition: "opacity 800ms ease-in-out",
            opacity: 0
          }, fadeTransitionStyles[state])
        }, /*#__PURE__*/_react["default"].createElement("h2", null, "Great Job!"), /*#__PURE__*/_react["default"].createElement("h3", null, "You've loaded all the cargo."));
      }) : null) : null, /*#__PURE__*/_react["default"].createElement("img", {
        className: "game-background",
        src: this.props.backgroundFullSrc
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.resizingWindow);
    }
  }]);
  return CargoGame;
}(_react.Component);
CargoGame.defaultProps = {};
CargoGame.propTypes = {
  introText: _propTypes["default"].string,
  introTitle: _propTypes["default"].string,
  items: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  backgroundSrc: _propTypes["default"].string,
  backgroundFullSrc: _propTypes["default"].string,
  spritesSrc: _propTypes["default"].string
};
var _default = CargoGame;
exports["default"] = _default;